import { styled as l, modifier as n, css as s } from "@lokalise/styled";
import { spacing as e } from "../../utils/theme/index.js";
const $ = l.div`
	display: flex;
	gap: ${({ $rowGap: i }) => e(i)} ${({ $columnGap: i }) => e(i)};
	max-width: 100%;
	align-items: ${({ $alignItems: i }) => i};
	justify-content: ${({ $justifyContent: i }) => i};
	flex-wrap: ${({ $flexWrap: i }) => i};
	flex-direction: ${({ $flexDirection: i }) => i};
	flex-basis: ${({ $basis: i }) => i};
	flex-grow: ${({ $grow: i }) => i};
	flex-shrink: ${({ $shrink: i }) => i};
	align-self: ${({ $alignSelf: i }) => i};
	${n(
  "$inline",
  s`
			display: inline-flex;
		`
)}
`;
export {
  $ as Container
};
//# sourceMappingURL=styles.js.map
